const moduleName = "Guías";

const READ_WAREHOUSES = "Ver listado de bodegas";

export default {
  moduleName,
  READ_WAREHOUSES
};
